import { OreDivider, OreHeading, OreStack } from '@edenredespana/oreneta'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { createApiBankAccountRepository } from '@/Contract/infrastructure'
import { AccountProvider } from '@/Contract/ui/context'
import { AccountingStatusBanner } from '@/Contract/ui/molecules'
import { createApiInvoiceRepository } from '@/Invoices/infrastructure'
import { InvoiceProvider } from '@/Invoices/ui/context'
import { invoicesTranslation } from '@/Invoices/ui/invoicesTranslation'
import { InvoicesList } from '@/Invoices/ui/organisms'
import { WebTagPermissionEnum } from '@/Shared/domain'
import { PageWrapper } from '@/Shared/ui/layout'
import { navigationRoutes } from '@/Shared/ui/routers'
import { useWebTagPermissions } from '@/User/context'
import { useUserData } from '@/User/ui/context'

export const InvoicesPage = (): JSX.Element => {
  const { t } = useTranslation()
  const { merchant } = useUserData()
  const { hasPermission } = useWebTagPermissions()
  useEffect(() => {
    if (!hasPermission(WebTagPermissionEnum.VIEW_SHOW_INVOICES)) {
      window.location.href = navigationRoutes.home
    }
  }, [])

  return (
    <AccountProvider
      merchantId={merchant.id}
      repository={createApiBankAccountRepository()}
      origin={navigationRoutes.invoices}
    >
      <InvoiceProvider repository={createApiInvoiceRepository()}>
        <PageWrapper
          paddingSmaller
          paddingTop={8}
          style={{
            paddingRight: 40,
            paddingLeft: 40,
            minWidth: '-webkit-fill-available',
            marginRight: 0,
            marginLeft: 0,
          }}
        >
          <OreHeading as="h1" size="title-sm">
            {t(invoicesTranslation.title)}
          </OreHeading>
          <OreDivider space="larger-bottom" />
          <OreStack space="xlarge" placeContent="stretch">
            {hasPermission(WebTagPermissionEnum.ACTION_BANK_ACCOUNT_CHANGE) && (
              <AccountingStatusBanner origin={navigationRoutes.invoices} />
            )}
            <InvoicesList />
          </OreStack>
        </PageWrapper>
      </InvoiceProvider>
    </AccountProvider>
  )
}
